export const messages = {
  en: {
    batchPayFeeOrder: {
      allSelect: 'Select All',
      allCancel: 'Cancel All',
      currentSelect: 'Select Current',
      currentCancel: 'Cancel Current',
      back: 'Back',
      scanPay: 'Scan Payment',
      submitPay: 'Submit Payment',
      noPayableFee: 'No payable fees currently'
    },
    batchPayConfirm: {
      title: 'Payment Confirmation',
      feeAmount: 'Payment Amount:',
      discountAmount: 'Discount Amount:',
      transferAmount: 'Transfer Amount:',
      transferObject: 'Transfer Object:',
      transferFee: 'Transfer Fee:',
      accountDeduction: 'Account Deduction:',
      paymentMethod: 'Payment Method:',
      remark: 'Remark:',
      authCode: 'Authorization Code:',
      yuan: 'yuan',
      selectTransferObject: 'Required, please select transfer object',
      selectTransferFee: 'Required, please select transfer fee',
      selectDeductionAccount: 'Please select deduction account',
      selectPaymentMethod: 'Required, please select payment method',
      enterRemark: 'Please enter remark',
      scanCode: 'Please scan with barcode scanner',
      scanQrCode: 'Please use WeChat/Alipay to scan the QR code to complete payment',
      generatingQrCode: 'Generating payment QR code...',
      close: 'Close',
      confirmPayment: 'Confirm Payment',
      payTip: 'Payment Notice',
      paySuccess: 'Payment Successful',
      back: 'Back',
      mergePrint: 'Merge Print',
      printReceipt: 'Print Receipt'
    },
    batchPrePayFeeDialog: {
      title: 'Prepayment',
      feeName: 'Fee Name',
      monthPrice: 'Monthly Price',
      description: 'Description',
      receivableAmount: 'Receivable Amount',
      months: 'Months',
      startMonth: 'Start Month',
      selectTransferFee: 'Required, please select transfer fee',
      selectMonths: 'Select months',
      monthsUnit: 'months',
      cancel: 'Cancel',
      confirm: 'Confirm'
    
  },
    batchFeeCycle: {
      paymentCycle: 'Payment Cycle',
      selectCycleTip: 'Please select payment cycle',
      default: 'Default',
      customCycle: 'Custom Cycle',
      customAmount: 'Custom Amount',
      customEndTime: 'Custom End Time',
      actualCycle: 'Actual Cycle',
      enterActualCycle: 'Enter actual cycle',
      endTime: 'End Time',
      selectEndTime: 'Select end time',
      enterCustomAmount: 'Enter custom amount'
    }
  },
  zh: {
    batchPayFeeOrder: {
      allSelect: '全部选择',
      allCancel: '全部取消',
      currentSelect: '当前选择',
      currentCancel: '当前取消',
      back: '返回',
      scanPay: '扫码收费',
      submitPay: '提交收费',
      noPayableFee: '当前没有可缴费用'
    },
    batchPayConfirm: {
      title: '收费确认',
      feeAmount: '缴费金额：',
      discountAmount: '优惠金额：',
      transferAmount: '转存金额：',
      transferObject: '转存对象：',
      transferFee: '转存费用：',
      accountDeduction: '账户扣款：',
      paymentMethod: '支付方式：',
      remark: '备注：',
      authCode: '授权码：',
      yuan: '元',
      selectTransferObject: '必填，请选择转存对象',
      selectTransferFee: '必填，请选择转存费用',
      selectDeductionAccount: '请选择扣款账户',
      selectPaymentMethod: '必填，请选择支付方式',
      enterRemark: '请填写备注',
      scanCode: '请用扫码枪扫码',
      scanQrCode: '请使用微信/支付宝扫描二维码完成支付',
      generatingQrCode: '正在生成支付二维码...',
      close: '关闭',
      confirmPayment: '确定收费',
      payTip: '缴费提示',
      paySuccess: '缴费成功',
      back: '返回',
      mergePrint: '合并打印',
      printReceipt: '打印收据'
    },
    batchPrePayFeeDialog: {
      title: '预付款',
      feeName: '费用名称',
      monthPrice: '月单价',
      description: '说明',
      receivableAmount: '应收金额',
      months: '月份',
      startMonth: '起始月',
      selectTransferFee: '必填，请选择转存费用',
      selectMonths: '选择月份',
      monthsUnit: '个月',
      cancel: '取消',
      confirm: '确定'
    },
    batchFeeCycle: {
      paymentCycle: '缴费周期',
      selectCycleTip: '必填，请选择缴费周期',
      default: '默认',
      customCycle: '自定义周期',
      customAmount: '自定义金额',
      customEndTime: '自定义结束时间',
      actualCycle: '实际周期',
      enterActualCycle: '请输入实际周期',
      endTime: '缴费结束时间',
      selectEndTime: '缴费结束时间',
      enterCustomAmount: '请输入自定义金额'
    }
  },
  'zh-TW': {
    batchPayFeeOrder: {
      allSelect: '全部選擇',
      allCancel: '全部取消',
      currentSelect: '當前選擇',
      currentCancel: '當前取消',
      back: '返回',
      scanPay: '掃碼收費',
      submitPay: '提交收費',
      noPayableFee: '當前沒有可繳費用'
    },
    batchPayConfirm: {
      title: '收費確認',
      feeAmount: '繳費金額：',
      discountAmount: '優惠金額：',
      transferAmount: '轉存金額：',
      transferObject: '轉存對象：',
      transferFee: '轉存費用：',
      accountDeduction: '帳戶扣款：',
      paymentMethod: '支付方式：',
      remark: '備註：',
      authCode: '授權碼：',
      yuan: '元',
      selectTransferObject: '必填，請選擇轉存對象',
      selectTransferFee: '必填，請選擇轉存費用',
      selectDeductionAccount: '請選擇扣款帳戶',
      selectPaymentMethod: '必填，請選擇支付方式',
      enterRemark: '請填寫備註',
      scanCode: '請用掃碼槍掃碼',
      scanQrCode: '請使用微信/支付寶掃描二維碼完成支付',
      generatingQrCode: '正在生成支付二維碼...',
      close: '關閉',
      confirmPayment: '確定收費',
      payTip: '繳費提示',
      paySuccess: '繳費成功',
      back: '返回',
      mergePrint: '合併列印',
      printReceipt: '列印收據'
    },
    batchPrePayFeeDialog: {
      title: '預付款',
      feeName: '費用名稱',
      monthPrice: '月單價',
      description: '說明',
      receivableAmount: '應收金額',
      months: '月份',
      startMonth: '起始月',
      selectTransferFee: '必填，請選擇轉存費用',
      selectMonths: '選擇月份',
      monthsUnit: '個月',
      cancel: '取消',
      confirm: '確定'
    },
    batchFeeCycle: {
      paymentCycle: '繳費週期',
      selectCycleTip: '必填，請選擇繳費週期',
      default: '默認',
      customCycle: '自訂義週期',
      customAmount: '自訂義金額',
      customEndTime: '自訂義結束時間',
      actualCycle: '實際週期',
      enterActualCycle: '請輸入實際週期',
      endTime: '繳費結束時間',
      selectEndTime: '繳費結束時間',
      enterCustomAmount: '請輸入自訂義金額'
    }
  }
}